const id = 'sheet1'

export default {
  id,
  options: {
    Def: {
      RelWidth: 1
    },
    Cols: [
      {
        Header: '열1',
        Name: 'colName1',
        Type: 'Text'
      },
      {
        Header: '열2',
        Name: 'colName2',
        Type: 'Text',
        Align: 'center'
      }
    ]
  }
}
